// react
import React from 'react'
import { useState } from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import { ListView, NewEntityDialog } from '@st-operations/uikit/src/v2/index.js'
import Header from '_components/header/index.jsx'

// Styles
import './styles.scss'

import { ENTITY } from './constants'

// TTD Audiences Page
const TTDAudiences = () => {
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  return (
    <div id="ttd-audiences-page" className="ttd-audiences">
      <Header
        title="TTD Audiences"
        actions={[
          {
            children: 'Create New TTD Audience',
            onClick: toggleModal,
          },
        ]}
      />
      <ListView
        columns={[
          {
            name: 'Display Name',
            key: 'DisplayName',
            link: `/${ENTITY}/:ProviderElementId`,
          },
          {
            name: 'Provider Element Id',
            key: 'ProviderElementId',
            link: `/${ENTITY}/:ProviderElementId`,
          },
          {
            name: 'Parent Element Id',
            key: 'ParentElementId',
            link: `/${ENTITY}/:ParentElementId`,
          },
          {
            name: 'Received IDs Count',
            key: 'ReceivedIDsCount',
          },
          {
            name: 'Active IDs Count',
            key: 'ActiveIDsCount',
          },
          {
            name: 'Last Updated At UTC',
            key: 'LastUpdatedAtUTC',
          },
        ]}
        entities={ENTITY}
        fields={[
          'DisplayName',
          'ProviderElementId',
          'ParentElementId',
          'ReceivedIDsCount',
          'ActiveIDsCount',
          'LastUpdatedAtUTC',
        ]}
        searchable={true}
        sort_dir={1}
        sort_key={'displayName'}
      />
      <If condition={modalOpen}>
        <Dialog close={toggleModal} open={modalOpen}>
          <NewEntityDialog close={toggleModal} entities={ENTITY} title="Please enter a name" />
        </Dialog>
      </If>
    </div>
  )
}

// export
export default TTDAudiences
